export { default } from './InfoBar';
